export function parseCurrency(value: any): number {
  if (value === null || value === undefined) {
    return 0;
  }
  if (typeof value === "number") {
    return value;
  }

  const raw = String(value).trim();
  if (!raw) {
    return 0;
  }

  // Remover símbolos de moeda e espaços, manter dígitos, hífen, ponto e vírgula
  let normalized = raw.replace(/\s+/g, "").replace(/[^0-9,.-]/g, "");
  if (!normalized) {
    return 0;
  }

  const hasComma = normalized.indexOf(",") >= 0;
  const hasDot = normalized.indexOf(".") >= 0;
  if (hasComma && hasDot) {
    normalized = normalized.replace(/\./g, "").replace(/,/g, ".");
  } else if (hasComma && !hasDot) {
    normalized = normalized.replace(/,/g, ".");
  }

  const parsed = Number(normalized);
  return Number.isNaN(parsed) ? 0 : parsed;
}

export function roundToCents(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}
